import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft } from 'lucide-react';
import Footer from '../components/Footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PhotographyDetail = () => {
  const { id } = useParams();
  const [photo, setPhoto] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPhoto = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/photography/${id}`);
        setPhoto(response.data);
      } catch (error) {
        console.error('Error fetching photography:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPhoto();
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <p className="text-dark">Loading...</p>
      </div>
    );
  }

  if (!photo) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <div className="text-center">
          <p className="text-dark mb-4">Photography project not found</p>
          <Link to="/" className="text-green hover:underline">
            Return home
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="photography-detail-page" className="bg-cream text-dark min-h-screen">
      <div className="pt-32 pb-24">
        <div className="container mx-auto px-6 md:px-12 max-w-[1200px]">
          <Link
            to="/"
            data-testid="back-link"
            className="inline-flex items-center gap-2 text-sm uppercase tracking-widest text-dark hover:text-green transition-colors mb-12"
          >
            <ArrowLeft size={16} />
            Back to Home
          </Link>

          <div className="flex flex-wrap gap-2 mb-6">
            {photo.tags.map((tag, idx) => (
              <span
                key={idx}
                className="px-3 py-1 rounded-full text-xs uppercase tracking-wider bg-yellow text-dark border border-dark/20"
              >
                {tag}
              </span>
            ))}
          </div>

          <h1
            data-testid="photography-title"
            className="text-4xl md:text-6xl lg:text-7xl font-bold uppercase mb-8 text-green"
            style={{ fontFamily: "'Anton', sans-serif" }}
          >
            {photo.title}
          </h1>

          <p className="text-xl md:text-2xl leading-relaxed font-light mb-12 text-dark/80">
            {photo.description}
          </p>

          <div className="columns-1 md:columns-2 gap-6 space-y-6">
            {photo.images.map((image, idx) => (
              <div key={idx} className="break-inside-avoid">
                <img
                  src={image}
                  alt={`${photo.title} ${idx + 1}`}
                  className="w-full rounded-lg shadow-lg"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PhotographyDetail;
